export enum ActionEnum {
    READ = 'read',
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
}

export const actionEnumIndex = Object.values(ActionEnum).reduce((acc, it, i) => {
    acc[it] = i;
    return acc;
}, {} as Record<ActionEnum, number>);

export function actionEnumAlterAction(action: string | ActionEnum): boolean {
    return [ActionEnum.CREATE, ActionEnum.UPDATE].includes(action as ActionEnum) || action == '';
}
